export default zipCode => zipCode.replace(/([\d]{4})([\w]{2})/, '$1 $2').toUpperCase();



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/normalizeNLZipCode.js
 **/